// @vue/component
import {useStrategyDetailsStore} from "@/stores/CrossWalkAnalysis/strategyDetails";
import {storeToRefs} from "pinia";
import { MDBBtn, MDBIcon, MDBTooltip } from 'mdb-vue-ui-kit';
import {useCrosswalkChallengeStore} from "@/stores/CrossWalkAnalysis/challenge";

export default {
  name: 'StrategySetup',

  components: {MDBBtn, MDBIcon, MDBTooltip},

  mixins: [],

  props: {},

  setup() {
    const strategyDetailsStore = useStrategyDetailsStore()
    const challengeStore = useCrosswalkChallengeStore()
    const { editMode } =  storeToRefs(challengeStore)
    const { matrixType } =  storeToRefs(strategyDetailsStore)
    const { goalNumber } =  storeToRefs(strategyDetailsStore)

    return { strategyDetailsStore, matrixType, goalNumber, editMode}

  },

  data () {
    return {
      goals: [
        {
          "id": "1",
          "name": "1: No Poverty",
          "description": "End poverty in all its forms everywhere",
          "targets": [
            {
              "id": "1.1",
              "number": "1.1",
              "name": "By 2030, eradicate extreme poverty for all people everywhere, currently measured as people living on less than $1.25 a day"
            },
            {
              "id": "1.2",
              "number": "1.2",
              "name": "By 2030, reduce at least by half the proportion of men, women and children of all ages living in poverty in all its dimensions according to national definitions"
            },
            {
              "id": "1.3",
              "number": "1.3",
              "name": "Implement nationally appropriate social protection systems and measures for all, including floors, and by 2030 achieve substantial coverage of the poor and the vulnerable"
            },
            {
              "id": "1.4",
              "number": "1.4",
              "name": "By 2030, ensure that all men and women, in particular the poor and the vulnerable, have equal rights to economic resources, as well as access to basic services, ownership and control over land and other forms of property, inheritance, natural resources, appropriate new technology and financial services, including microfinance"
            },
            {
              "id": "1.5",
              "number": "1.5",
              "name": "By 2030, build the resilience of the poor and those in vulnerable situations and reduce their exposure and vulnerability to climate-related extreme events and other economic, social and environmental shocks and disasters"
            },
            {
              "id": "1.a",
              "number": "1.a",
              "name": "Ensure significant mobilization of resources from a variety of sources, including through enhanced development cooperation, in order to provide adequate and predictable means for developing countries, in particular least developed countries, to implement programmes and policies to end poverty in all its dimensions"
            },
            {
              "id": "1.b",
              "number": "1.b",
              "name": "Create sound policy frameworks at the national, regional and international levels, based on pro-poor and gender-sensitive development strategies, to support accelerated investment in poverty eradication actions"
            }
          ]
        },
        {
          "id": "2",
          "name": "2: Zero Hunger",
          "description": "End hunger, achieve food security and improved nutrition and promote sustainable agriculture",
          "targets": [
            {
              "id": "2.1",
              "number": "2.1",
              "name": "By 2030, end hunger and ensure access by all people, in particular the poor and people in vulnerable situations, including infants, to safe, nutritious and sufficient food all year round"
            },
            {
              "id": "2.2",
              "number": "2.2",
              "name": "By 2030, end all forms of malnutrition, including achieving, by 2025, the internationally agreed targets on stunting and wasting in children under 5 years of age, and address the nutritional needs of adolescent girls, pregnant and lactating women, and older persons"
            },
            {
              "id": "2.3",
              "number": "2.3",
              "name": "By 2030, double the agricultural productivity and incomes of small-scale food producers, in particular women, indigenous peoples, family farmers, pastoralists and fishers, including through secure and equal access to land, other productive resources and inputs, knowledge, financial services, markets and opportunities for value addition and non-farm employment"
            },
            {
              "id": "2.4",
              "number": "2.4",
              "name": "By 2030, ensure sustainable food production systems and implement resilient agricultural practices that increase productivity and production, that help maintain ecosystems, that strengthen capacity for adaptation to climate change, extreme weather, drought, flooding and other disasters, and that progressively improve land and soil quality"
            },
            {
              "id": "2.5",
              "number": "2.5",
              "name": "By 2020, maintain the genetic diversity of seeds, cultivated plants and farmed and domesticated animals and their related wild species, including through soundly managed and diversified seed and plant banks at the national, regional and international levels, and promote access to and fair and equitable sharing of benefits arising from the utilization of genetic resources and associated traditional knowledge, as internationally agreed"
            },
            {
              "id": "2.a",
              "number": "2.a",
              "name": "Increase investment, including through enhanced international cooperation, in rural infrastructure, agricultural research and extension services, technology development and plant and livestock gene banks to enhance agricultural productive capacity in developing countries, in particular least developed countries"
            },
            {
              "id": "2.b",
              "number": "2.b",
              "name": "Correct and prevent trade restrictions and distortions in world agricultural markets, including through the parallel elimination of all forms of agricultural export subsidies and all export measures with equivalent effect, in accordance with the mandate of the Doha Development Round"
            },
            {
              "id": "2.c",
              "number": "2.c",
              "name": "Adopt measures to ensure the proper functioning of food commodity markets and their derivatives, and facilitate timely access to market information, including on food reserves, in order to help limit extreme food price volatility"
            }
          ]
        },
        {
          "id": "3",
          "name": "3: Good Health and Well-Being",
          "description": "Ensure healthy lives and promote well-being for all at all ages",
          "targets": [
            {
              "id": "3.1",
              "number": "3.1",
              "name": "By 2030, reduce the global maternal mortality ratio to less than 70 per 100,000 live births"
            },
            {
              "id": "3.2",
              "number": "3.2",
              "name": "End preventable deaths of newborns and children under 5 years of age, with all countries aiming to reduce neonatal mortality to at least as low as 12 per 1,000 live births and under-5 mortality to at least as low as 25 per 1,000 live births"
            },
            {
              "id": "3.3",
              "number": "3.3",
              "name": "By 2030, end the epidemics of AIDS, tuberculosis, malaria and neglected tropical diseases and combat hepatitis, water-borne diseases and other communicable diseases"
            },
            {
              "id": "3.4",
              "number": "3.4",
              "name": "By 2030, reduce by one third premature mortality from non-communicable diseases through prevention and treatment and promote mental health and well-being"
            },
            {
              "id": "3.5",
              "number": "3.5",
              "name": "Strengthen the prevention and treatment of substance abuse, including narcotic drug abuse and harmful use of alcohol"
            },
            {
              "id": "3.6",
              "number": "3.6",
              "name": "By 2020, halve the number of global deaths and injuries from road traffic accidents"
            },
            {
              "id": "3.7",
              "number": "3.7",
              "name": "By 2030, ensure universal access to sexual and reproductive health-care services, including for family planning, information and education, and the integration of reproductive health into national strategies and programmes"
            },
            {
              "id": "3.8",
              "number": "3.8",
              "name": "Achieve universal health coverage, including financial risk protection, access to quality essential health-care services and access to safe, effective, quality and affordable essential medicines and vaccines for all"
            },
            {
              "id": "3.9",
              "number": "3.9",
              "name": "By 2030, substantially reduce the number of deaths and illnesses from hazardous chemicals and air, water and soil pollution and contamination"
            },
            {
              "id": "3.a",
              "number": "3.a",
              "name": "Strengthen the implementation of the World Health Organization Framework Convention on Tobacco Control in all countries, as appropriate"
            },
            {
              "id": "3.b",
              "number": "3.b",
              "name": "Support the research and development of vaccines and medicines for the communicable and non-communicable diseases that primarily affect developing countries, provide access to affordable essential medicines and vaccines, in accordance with the Doha Declaration on the TRIPS Agreement and Public Health, which affirms the right of developing countries to use to the full the provisions in the Agreement on Trade-Related Aspects of Intellectual Property Rights regarding flexibilities to protect public health, and, in particular, provide access to medicines for all"
            },
            {
              "id": "3.c",
              "number": "3.c",
              "name": "Substantially increase health financing and the recruitment, development, training and retention of the health workforce in developing countries, especially in least developed countries and small island developing States"
            },
            {
              "id": "3.d",
              "number": "3.d",
              "name": "Strengthen the capacity of all countries, in particular developing countries, for early warning, risk reduction and management of national and global health risks"
            }
          ]
        },
        {
          "id": "4",
          "name": "4: Quality Education",
          "description": "Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all",
          "targets": [
            {
              "id": "4.1",
              "number": "4.1",
              "name": "By 2030, ensure that all girls and boys complete free, equitable and quality primary and secondary education leading to relevant and effective learning outcomes"
            },
            {
              "id": "4.2",
              "number": "4.2",
              "name": "By 2030, ensure that all girls and boys have access to quality early childhood development, care, and pre-primary education so that they are ready for primary education"
            },
            {
              "id": "4.3",
              "number": "4.3",
              "name": "By 2030, ensure equal access for all women and men to affordable and quality technical, vocational, and tertiary education, including university"
            },
            {
              "id": "4.4",
              "number": "4.4",
              "name": "By 2030, substantially increase the number of youth and adults who have relevant skills, including technical and vocational skills, for employment, decent jobs, and entrepreneurship"
            },
            {
              "id": "4.5",
              "number": "4.5",
              "name": "By 2030, eliminate gender disparities in education and ensure equal access to all levels of education and vocational training for the vulnerable, including persons with disabilities, indigenous peoples, and children in vulnerable situations"
            },
            {
              "id": "4.6",
              "number": "4.6",
              "name": "By 2030, ensure that all youth and a substantial proportion of adults, both men and women, achieve literacy and numeracy"
            },
            {
              "id": "4.7",
              "number": "4.7",
              "name": "By 2030, ensure that all learners acquire the knowledge and skills needed to promote sustainable development, including, among others, through education for sustainable development and sustainable lifestyles, human rights, gender equality, promotion of a culture of peace and non-violence, global citizenship, and appreciation of cultural diversity and of culture's contribution to sustainable development"
            },
            {
              "id": "4.a",
              "number": "4.a",
              "name": "Build and upgrade education facilities that are child, disability, and gender sensitive and provide safe, nonviolent, inclusive, and effective learning environments for all"
            },
            {
              "id": "4.b",
              "number": "4.b",
              "name": "By 2020, substantially expand globally the number of scholarships available to developing countries, in particular least developed countries, small island developing States, and African countries, for enrolment in higher education, including vocational training and information and communications technology, technical, engineering, and scientific programs, in developed countries and other developing countries"
            },
            {
              "id": "4.c",
              "number": "4.c",
              "name": "By 2030, substantially increase the supply of qualified teachers, including through international cooperation for teacher training in developing countries, especially least developed countries and small island developing States"
            }
          ]
        },
        {
          "id": "5",
          "name": "5: Gender Equality",
          "description": "Achieve gender equality and empower all women and girls",
          "targets": [
            {
              "id": "5.1",
              "number": "5.1",
              "name": "End all forms of discrimination against all women and girls everywhere"
            },
            {
              "id": "5.2",
              "number": "5.2",
              "name": "Eliminate all forms of violence against all women and girls in the public and private spheres, including trafficking and sexual and other types of exploitation"
            },
            {
              "id": "5.3",
              "number": "5.3",
              "name": "Eliminate all harmful practices, such as child, early and forced marriage and female genital mutilation"
            },
            {
              "id": "5.4",
              "number": "5.4",
              "name": "Recognize and value unpaid care and domestic work through the provision of public services, infrastructure and social protection policies and the promotion of shared responsibility within the household and the family as nationally appropriate"
            },
            {
              "id": "5.5",
              "number": "5.5",
              "name": "Ensure women's full and effective participation and equal opportunities for leadership at all levels of decision-making in political, economic and public life"
            },
            {
              "id": "5.6",
              "number": "5.6",
              "name": "Ensure universal access to sexual and reproductive health and reproductive rights as agreed in accordance with the Programme of Action of the International Conference on Population and Development and the Beijing Platform for Action and the outcome documents of their review conferences"
            },
            {
              "id": "5.a",
              "number": "5.a",
              "name": "Undertake reforms to give women equal rights to economic resources, as well as access to ownership and control over land and other forms of property, financial services, inheritance and natural resources, in accordance with national laws"
            },
            {
              "id": "5.b",
              "number": "5.b",
              "name": "Enhance the use of enabling technology, in particular information and communications technology, to promote the empowerment of women"
            },
            {
              "id": "5.c",
              "number": "5.c",
              "name": "Adopt and strengthen sound policies and enforceable legislation for the promotion of gender equality and the empowerment of all women and girls at all levels"
            }
          ]
        },
        {
          "id": "6",
          "name": "6: Clean Water and Sanitation",
          "description": "Ensure availability and sustainable management of water and sanitation for all",
          "targets": [
            {
              "id": "6.1",
              "number": "6.1",
              "name": "By 2030, achieve universal and equitable Achieve universal access to safe and affordable drinking water for all"
            },
            {
              "id": "6.2",
              "number": "6.2",
              "name": "By 2030, achieve access to adequate and equitable sanitation and hygiene for all and end open defecation, paying special attention to the needs of women and girls and those in vulnerable situations"
            },
            {
              "id": "6.3",
              "number": "6.3",
              "name": "By 2030, improve water quality by reducing pollution, eliminating dumping and minimizing release of hazardous chemicals and materials, halving the proportion of untreated wastewater and substantially increasing recycling and safe reuse globally"
            },
            {
              "id": "6.4",
              "number": "6.4",
              "name": "By 2030, substantially increase water-use efficiency across all sectors and ensure sustainable withdrawals and supply of freshwater to address water scarcity and substantially reduce the number of people suffering from water scarcity"
            },
            {
              "id": "6.5",
              "number": "6.5",
              "name": "By 2030, implement integrated water resources management at all levels, including through transboundary cooperation as appropriate"
            },
            {
              "id": "6.6",
              "number": "6.6",
              "name": "By 2020, protect and restore water-related ecosystems, including mountains, forests, wetlands, rivers, aquifers, and lakes"
            },
            {
              "id": "6.a",
              "number": "6.a",
              "name": "By 2030, expand international cooperation and capacity-building support to developing countries in water- and sanitation-related activities and programmes, including water harvesting, desalination, water efficiency, wastewater treatment, recycling and reuse technologies"
            },
            {
              "id": "6.b",
              "number": "6.b",
              "name": "Support and strengthen the participation of local communities in improving water and sanitation management"
            }
          ]
        },
        {
          "id": "7",
          "name": "7: Affordable and Clean Energy",
          "description": "Ensure access to affordable, reliable, sustainable and modern energy for all",
          "targets": [
            {
              "id": "7.1",
              "number": "7.1",
              "name": "By 2030, ensure universal access to affordable, reliable, and modern energy services"
            },
            {
              "id": "7.2",
              "number": "7.2",
              "name": "By 2030, increase substantially the share of renewable energy in the global energy mix"
            },
            {
              "id": "7.3",
              "number": "7.3",
              "name": "By 2030, double the global rate of improvement in energy efficiency"
            },
            {
              "id": "7.a",
              "number": "7.a",
              "name": "By 2030, enhance international cooperation to facilitate access to clean energy research and technology, including renewable energy, energy efficiency, and advanced and cleaner fossil-fuel technology, and promote investment in energy infrastructure and clean energy technology"
            },
            {
              "id": "7.b",
              "number": "7.b",
              "name": "By 2030, expand infrastructure and upgrade technology for supplying modern and sustainable energy services for all in developing countries, in particular least developed countries, small island developing States, and landlocked developing countries, in accordance with their respective programmes of support"
            }
          ]
        },
        {
          "id": "8",
          "name": "8: Decent Work and Economic Growth",
          "description": "Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all",
          "targets": [
            {
              "id": "8.1",
              "number": "8.1",
              "name": "Sustain per capita economic growth in accordance with national circumstances and, in particular, at least 7 percent gross domestic product growth per annum in the least developed countries"
            },
            {
              "id": "8.10",
              "number": "8.10",
              "name": "Strengthen the capacity of domestic financial institutions to encourage and expand access to banking, insurance and financial services for all"
            },
            {
              "id": "8.2",
              "number": "8.2",
              "name": "Achieve higher levels of economic productivity through diversification, technological upgrading, and innovation, including through a focus on high-value added and labour-intensive sectors"
            },
            {
              "id": "8.3",
              "number": "8.3",
              "name": "Promote development-oriented policies that support productive activities, decent job creation, entrepreneurship, creativity and innovation, and encourage the formalization and growth of micro-, small- and medium-sized enterprises, including through access to financial services"
            },
            {
              "id": "8.4",
              "number": "8.4",
              "name": "Improve progressively, through 2030, global resource efficiency in consumption and production and endeavour to decouple economic growth from environmental degradation, in accordance with the 10-year framework of programmes on sustainable consumption and production, with developed countries taking the lead"
            },
            {
              "id": "8.5",
              "number": "8.5",
              "name": "By 2030, achieve full and productive employment and decent work for all women and men, including for young people and persons with disabilities, and equal pay for work of equal value"
            },
            {
              "id": "8.6",
              "number": "8.6",
              "name": "By 2020, substantially reduce the proportion of youth not in employment, education or training"
            },
            {
              "id": "8.7",
              "number": "8.7",
              "name": "Take immediate and effective measures to eradicate forced labour, end modern slavery and human trafficking and secure the prohibition and elimination of the worst forms of child labour, including recruitment and use of child soldiers, and by 2025 end child labour in all its forms"
            },
            {
              "id": "8.8",
              "number": "8.8",
              "name": "Protect labour rights and promote safe and secure working environments for all workers, including migrant workers, in particular women migrants, and those in precarious employment"
            },
            {
              "id": "8.9",
              "number": "8.9",
              "name": "By 2030, devise and implement policies to promote sustainable tourism that creates jobs and promotes local culture and products"
            },
            {
              "id": "8.a",
              "number": "8.a",
              "name": "Increase Aid for Trade support for developing countries, in particular least developed countries, including through the Enhanced Integrated Framework for Trade-Related Technical Assistance to Least Developed Countries"
            },
            {
              "id": "8.b",
              "number": "8.b",
              "name": "By 2020, develop and operationalize a global strategy for youth employment and implement the Global Jobs Pact of the International Labour Organization"
            }
          ]
        },
        {
          "id": "9",
          "name": "9: Industry, Innovation and Infrastructure",
          "description": "Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation",
          "targets": [
            {
              "id": "9.1",
              "number": "9.1",
              "name": "Develop quality, reliable, sustainable and resilient infrastructure, including regional and transborder infrastructure, to support economic development and human well-being, with a focus on affordable and equitable access for all"
            },
            {
              "id": "9.2",
              "number": "9.2",
              "name": "Promote inclusive and sustainable industrialization and, by 2030, significantly raise industry’s share of employment and gross domestic product, in line with national circumstances, and double its share in least developed countries"
            },
            {
              "id": "9.3",
              "number": "9.3",
              "name": "Increase the access of small-scale industrial and other enterprises, in particular in developing countries, to financial services, including affordable credit, and their integration into value chains and markets"
            },
            {
              "id": "9.4",
              "number": "9.4",
              "name": "By 2030, upgrade infrastructure and retrofit industries to make them sustainable, with increased resource-use efficiency and greater adoption of clean and environmentally sound technologies and industrial processes, with all countries taking action in accordance with their respective capabilities"
            },
            {
              "id": "9.5",
              "number": "9.5",
              "name": "Enhance scientific research, upgrade the technological capabilities of industrial sectors in all countries, in particular developing countries, including, by 2030, encouraging innovation and substantially increasing the number of research and development workers per 1 million people and public and private research and development spending"
            },
            {
              "id": "9.a",
              "number": "9.a",
              "name": "Facilitate sustainable and resilient infrastructure development in developing countries through enhanced financial, technological and technical support to African countries, least developed countries, landlocked developing countries and small island developing States"
            },
            {
              "id": "9.b",
              "number": "9.b",
              "name": "Support domestic technology development, research and innovation in developing countries, including by ensuring a conducive policy environment for, inter alia, industrial diversification and value addition to commodities"
            },
            {
              "id": "9.c",
              "number": "9.c",
              "name": "Significantly increase access to information and communications technology and strive to provide universal and affordable access to the Internet in least developed countries by 2020"
            }
          ]
        },
        {
          "id": "10",
          "name": "10: Reduced Inequalities",
          "description": "Reduce inequality within and among countries",
          "targets": [
            {
              "id": "10.1",
              "number": "10.1",
              "name": "By 2030, progressively achieve and sustain income growth of the bottom 40 per cent of the population at a rate higher than the national average"
            },
            {
              "id": "10.2",
              "number": "10.2",
              "name": "By 2030, empower and promote the social, economic and political inclusion of all, irrespective of age, sex, disability, race, ethnicity, origin, religion or economic or other status"
            },
            {
              "id": "10.3",
              "number": "10.3",
              "name": "Ensure equal opportunity and reduce inequalities of outcome, including by eliminating discriminatory laws, policies and practices and promoting appropriate legislation, policies and action in this regard"
            },
            {
              "id": "10.4",
              "number": "10.4",
              "name": "Adopt policies, especially fiscal, wage and social protection policies, and progressively achieve greater equality"
            },
            {
              "id": "10.5",
              "number": "10.5",
              "name": "Improve the regulation and monitoring of global financial markets and institutions and strengthen the implementation of such regulations"
            },
            {
              "id": "10.6",
              "number": "10.6",
              "name": "Ensure enhanced representation and voice for developing countries in decision-making in global international economic and financial institutions in order to deliver more effective, credible, accountable and legitimate institutions"
            },
            {
              "id": "10.7",
              "number": "10.7",
              "name": "Facilitate orderly, safe, regular and responsible migration and mobility of people, including through the implementation of planned and well-managed migration policies"
            },
            {
              "id": "10.a",
              "number": "10.a",
              "name": "Implement the principle of special and differential treatment for developing countries, in particular least developed countries, in accordance with World Trade Organization agreements"
            },
            {
              "id": "10.b",
              "number": "10.b",
              "name": "Encourage official development assistance and financial flows, including foreign direct investment, to States where the need is greatest, in particular least developed countries, African countries, small island developing States and landlocked developing countries, in accordance with their national plans and programmes"
            },
            {
              "id": "10.c",
              "number": "10.c",
              "name": "By 2030, reduce to less than 3 per cent the transaction costs of migrant remittances and eliminate remittance corridors with costs higher than 5 per cent"
            }
          ]
        },
        {
          "id": "11",
          "name": "11: Sustainable Cities and Communities",
          "description": "Make cities and human settlements inclusive, safe, resilient and sustainable",
          "targets": [
            {
              "id": "11.1",
              "number": "11.1",
              "name": "By 2030, ensure access for all to adequate, safe and affordable housing and basic services and upgrade slums"
            },
            {
              "id": "11.2",
              "number": "11.2",
              "name": "By 2030, provide access to safe, affordable, accessible and sustainable transport systems for all, improving road safety, notably by expanding public transport, with special attention to the needs of those in vulnerable situations, women, children, persons with disabilities and older persons"
            },
            {
              "id": "11.3",
              "number": "11.3",
              "name": "By 2030, enhance inclusive and sustainable urbanization and capacity for participatory, integrated and sustainable human settlement planning and management in all countries"
            },
            {
              "id": "11.4",
              "number": "11.4",
              "name": "Strengthen efforts to protect and safeguard the world’s cultural and natural heritage"
            },
            {
              "id": "11.5",
              "number": "11.5",
              "name": "By 2030, build the resilience of the poor and those in vulnerable situations and reduce their exposure and vulnerability to climate-related extreme events and other economic, social and environmental shocks and disasters"
            },
            {
              "id": "11.6",
              "number": "11.6",
              "name": "By 2030, reduce the adverse per capita environmental impact of cities, including by paying special attention to air quality and municipal and other waste management"
            },
            {
              "id": "11.7",
              "number": "11.7",
              "name": "By 2030, provide universal access to safe, inclusive and accessible, green and public spaces, in particular for women and children, older persons and persons with disabilities"
            },
            {
              "id": "11.a",
              "number": "11.a",
              "name": "Support positive economic, social and environmental links between urban, peri-urban and rural areas by strengthening national and regional development planning"
            },
            {
              "id": "11.b",
              "number": "11.b",
              "name": "By 2020, substantially increase the number of cities and human settlements adopting and implementing integrated policies and plans towards inclusion, resource efficiency, mitigation and adaptation to climate change, resilience to disasters, and develop and implement, in line with the Sendai Framework for Disaster Risk Reduction 2015-2030, holistic disaster risk management at all levels"
            },
            {
              "id": "11.c",
              "number": "11.c",
              "name": "Support least developed countries, including through financial and technical assistance, in building sustainable and resilient buildings utilizing local materials"
            }
          ]
        },
        {
          "id": "12",
          "name": "12: Responsible Consumption and Production",
          "description": "Ensure sustainable consumption and production patterns",
          "targets": [
            {
              "id": "12.1",
              "number": "12.1",
              "name": "Implement the 10-year framework of programmes on sustainable consumption and production, all countries taking action, with developed countries taking the lead, taking into account the development and capabilities of developing countries"
            },
            {
              "id": "12.2",
              "number": "12.2",
              "name": "By 2030, achieve the sustainable management and efficient use of natural resources"
            },
            {
              "id": "12.3",
              "number": "12.3",
              "name": "By 2030, halve per capita global food waste at the retail and consumer levels and reduce food losses along production and supply chains, including post-harvest losses"
            },
            {
              "id": "12.4",
              "number": "12.4",
              "name": "By 2020, achieve the environmentally sound management of chemicals and all wastes throughout their life cycle, in accordance with agreed international frameworks, and significantly reduce their release to air, water and soil in order to minimize their adverse impacts on human health and the environment"
            },
            {
              "id": "12.5",
              "number": "12.5",
              "name": "By 2030, substantially reduce waste generation through prevention, reduction, recycling, and reuse"
            },
            {
              "id": "12.6",
              "number": "12.6",
              "name": "Encourage companies, especially large and transnational companies, to adopt sustainable practices and to integrate sustainability information into their reporting cycle"
            },
            {
              "id": "12.7",
              "number": "12.7",
              "name": "Promote public procurement practices that are sustainable, in accordance with national policies and priorities"
            },
            {
              "id": "12.8",
              "number": "12.8",
              "name": "By 2030, ensure that people everywhere have the relevant information and awareness for sustainable development and lifestyles in harmony with nature"
            },
            {
              "id": "12.a",
              "number": "12.a",
              "name": "Support developing countries to strengthen their scientific and technological capacity to move towards more sustainable patterns of consumption and production"
            },
            {
              "id": "12.b",
              "number": "12.b",
              "name": "Develop and implement tools to monitor sustainable development impacts for sustainable tourism that creates jobs and promotes local culture and products"
            },
            {
              "id": "12.c",
              "number": "12.c",
              "name": "Rationalize inefficient fossil-fuel subsidies that encourage wasteful consumption by removing market distortions, in accordance with national circumstances, including by restructuring taxation and phasing out those harmful subsidies, where they exist, to reflect their environmental impacts, taking fully into account the specific needs and conditions of developing countries and minimizing the possible adverse impacts on their development in a manner that protects the poor and the affected communities"
            }
          ]
        },
        {
          "id": "13",
          "name": "13: Climate Action",
          "description": "Take urgent action to combat climate change and its impacts",
          "targets": [
            {
              "id": "13.1",
              "number": "13.1",
              "name": "Strengthen resilience and adaptive capacity to climate-related hazards and natural disasters in all countries"
            },
            {
              "id": "13.2",
              "number": "13.2",
              "name": "Integrate climate change measures into national policies, strategies and planning"
            },
            {
              "id": "13.3",
              "number": "13.3",
              "name": "Improve education, awareness-raising and human and institutional capacity on climate change mitigation, adaptation, impact reduction and early warning"
            },
            {
              "id": "13.a",
              "number": "13.a",
              "name": "Implement the commitment undertaken by developedcountry parties to the United Nations Framework Convention on Climate Change to a goal of mobilizing jointly $100 billion annually by 2020 from all sources to address the needs of developing countries in the context of meaningful mitigation actions and transparency on implementation and fully operationalize the Green Climate Fund through its capitalization as soon as possible "
            },
            {
              "id": "13.b",
              "number": "13.b",
              "name": "Promote mechanisms for raising capacity for effective climate change-related planning and management in least developed countries and small island developing states, including focusing on women, youth and local and marginalized communities"
            }
          ]
        },
        {
          "id": "14",
          "name": "14: Life Below Water",
          "description": "Conserve and sustainably use the oceans, seas and marine resources for sustainable development",
          "targets": [
            {
              "id": "14.1",
              "number": "14.1",
              "name": "By 2025, prevent and significantly reduce marine pollution of all kinds, in particular from land-based activities, including marine debris and nutrient pollution"
            },
            {
              "id": "14.2",
              "number": "14.2",
              "name": "By 2020, sustainably manage and protect marine and coastal ecosystems to avoid significant adverse impacts, including by strengthening their resilience, and take action for their restoration in order to achieve healthy and productive oceans"
            },
            {
              "id": "14.3",
              "number": "14.3",
              "name": "Minimize and address the impacts of ocean acidification, including through enhanced scientific cooperation at all levels"
            },
            {
              "id": "14.4",
              "number": "14.4",
              "name": "By 2020, effectively regulate harvesting and end overfishing, illegal, unreported and unregulated fishing and destructive fishing practices and implement science-based management plans, in order to restore fish stocks in the shortest time feasible, at least to levels that can produce maximum sustainable yield as determined by their biological characteristics"
            },
            {
              "id": "14.5",
              "number": "14.5",
              "name": "By 2020, conserve at least 10 percent of coastal and marine areas, consistent with national and international law and based on the best available scientific information"
            },
            {
              "id": "14.6",
              "number": "14.6",
              "name": "By 2020, prohibit certain forms of fisheries subsidies which contribute to overcapacity and overfishing, eliminate subsidies that contribute to illegal, unreported and unregulated fishing and refrain from introducing new such subsidies, recognizing that appropriate and effective special and differential treatment for developing and least developed countries should be an integral part of the World Trade Organization fisheries subsidies negotiation"
            },
            {
              "id": "14.7",
              "number": "14.7",
              "name": "By 2030, increase the economic benefits to small island developing states and least developed countries from the sustainable use of marine resources, including through sustainable management of fisheries, aquaculture and tourism"
            },
            {
              "id": "14.a",
              "number": "14.a",
              "name": "Increase scientific knowledge, develop research capacities and transfer marine technology, taking into account the Intergovernmental Oceanographic Commission Criteria and Guidelines on the Transfer of Marine Technology, in order to improve ocean health and to enhance the contribution of marine biodiversity to the development of developing countries, in particular small island developing states and least developed countries"
            },
            {
              "id": "14.b",
              "number": "14.b",
              "name": "Provide access for small-scale artisanal fishers to marine resources and markets"
            },
            {
              "id": "14.c",
              "number": "14.c",
              "name": "Enhance the conservation and sustainable use of oceans and their resources by implementing international law as reflected in United Nations Convention on the Law of the Sea, which provides the legal framework for the conservation and sustainable use of oceans and their resources, as recalled in paragraph 158 of \"The future we want\""
            }
          ]
        },
        {
          "id": "15",
          "name": "15: Life On Land",
          "description": "Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss",
          "targets": [
            {
              "id": "15.1",
              "number": "15.1",
              "name": "By 2020, ensure the conservation, restoration and sustainable use of terrestrial and inland freshwater ecosystems and their services, in particular forests, wetlands, mountains and drylands, in line with obligations under international agreements"
            },
            {
              "id": "15.2",
              "number": "15.2",
              "name": "By 2020, promote the implementation of sustainable management of all types of forests, halt deforestation, restore degraded forests and substantially increase afforestation and reforestation globally"
            },
            {
              "id": "15.3",
              "number": "15.3",
              "name": "By 2030, combat desertification, restore degraded land and soil, including land affected by desertification, drought and floods, and strive to achieve a land degradation-neutral world"
            },
            {
              "id": "15.4",
              "number": "15.4",
              "name": "By 2030, ensure the conservation of mountain ecosystems, including their biodiversity, to enhance their capacity to provide benefits that are essential for sustainable development"
            },
            {
              "id": "15.5",
              "number": "15.5",
              "name": "Take urgent and significant action to reduce the degradation of natural habitats, halt the loss of biodiversity and, by 2020, protect and prevent the extinction of threatened species"
            },
            {
              "id": "15.6",
              "number": "15.6",
              "name": "Promote fair and equitable sharing of the benefits arising from the utilization of genetic resources and promote appropriate access to such resources, as internationally agreed"
            },
            {
              "id": "15.7",
              "number": "15.7",
              "name": "Take urgent action to end poaching and trafficking of protected species of flora and fauna and address both demand and supply of illegal wildlife products"
            },
            {
              "id": "15.8",
              "number": "15.8",
              "name": "By 2020, introduce measures to prevent the introduction and significantly reduce the impact of invasive alien species on land and water ecosystems and control or eradicate the priority species"
            },
            {
              "id": "15.9",
              "number": "15.9",
              "name": "By 2020, integrate ecosystem and biodiversity values into national and local planning, development processes, poverty reduction strategies and accounts"
            },
            {
              "id": "15.a",
              "number": "15.a",
              "name": "Mobilize and significantly increase financial resources from all sources to conserve and sustainably use biodiversity and ecosystems"
            },
            {
              "id": "15.b",
              "number": "15.b",
              "name": "Mobilize significant resources from all sources and at all levels to finance sustainable forest management and provide adequate incentives to developing countries to advance such management, including for conservation and reforestation"
            },
            {
              "id": "15.c",
              "number": "15.c",
              "name": "Enhance global support for efforts to combat poaching and trafficking of protected species, including by increasing the capacity of local communities to pursue sustainable livelihood opportunities"
            }
          ]
        },
        {
          "id": "16",
          "name": "16: Peace, Justice and Strong Institutions",
          "description": "Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels",
          "targets": [
            {
              "id": "16.1",
              "number": "16.1",
              "name": "Significantly reduce all forms of violence and related death rates everywhere"
            },
            {
              "id": "16.2",
              "number": "16.2",
              "name": "End abuse, exploitation, trafficking, and all forms of violence against and torture of children"
            },
            {
              "id": "16.3",
              "number": "16.3",
              "name": "Promote the rule of law at the national and international levels and ensure equal access to justice for all"
            },
            {
              "id": "16.4",
              "number": "16.4",
              "name": "By 2030, significantly reduce illicit financial and arms flows, strengthen the recovery and return of stolen assets, and combat all forms of organized crime"
            },
            {
              "id": "16.5",
              "number": "16.5",
              "name": "Substantially reduce corruption and bribery in all their forms"
            },
            {
              "id": "16.6",
              "number": "16.6",
              "name": "Develop effective, accountable, and transparent institutions at all levels"
            },
            {
              "id": "16.7",
              "number": "16.7",
              "name": "Ensure responsive, inclusive, participatory, and representative decision-making at all levels"
            },
            {
              "id": "16.8",
              "number": "16.8",
              "name": "Broaden and strengthen the participation of developing countries in the institutions of global governance"
            },
            {
              "id": "16.9",
              "number": "16.9",
              "name": "By 2030, provide legal identity for all, including birth registration"
            },
            {
              "id": "16.10",
              "number": "16.10",
              "name": "Ensure public access to information and protect fundamental freedoms, in accordance with national legislation and international agreements"
            },
            {
              "id": "16.a",
              "number": "16.a",
              "name": "Strengthen relevant national institutions, including through international cooperation, for building capacity at all levels, in particular in developing countries, to prevent violence and combat terrorism and crime"
            },
            {
              "id": "16.b",
              "number": "16.b",
              "name": "Promote and enforce non-discriminatory laws and policies for sustainable development"
            }
          ]
        },
        {
          "id": "17",
          "name": "17: Partnerships for the Goals",
          "description": "Strengthen the means of implementation and revitalize the Global Partnership for Sustainable Development",
          "targets": [
            {
              "id": "17.1",
              "number": "17.1",
              "name": "Strengthen domestic resource mobilization, including through international support to developing countries, to improve domestic capacity for tax and other revenue collection"
            },
            {
              "id": "17.2",
              "number": "17.2",
              "name": "Developed countries to implement fully their official development assistance commitments, including the commitment by many developed countries to achieve the target of 0.7 percent of gross national income for official development assistance (ODA/GNI) to developing countries and 0.15 to 0.20 percent of ODA/GNI to least developed countries; ODA providers are encouraged to consider setting a target to provide at least 0.20 percent of ODA/GNI to least developed countries"
            },
            {
              "id": "17.3",
              "number": "17.3",
              "name": "Mobilize additional financial resources for developing countries from multiple sources"
            },
            {
              "id": "17.4",
              "number": "17.4",
              "name": "Assist developing countries in attaining long-term debt sustainability through coordinated policies aimed at fostering debt financing, debt relief, and debt restructuring, as appropriate, and address the external debt of highly indebted poor countries to reduce debt distress"
            },
            {
              "id": "17.5",
              "number": "17.5",
              "name": "Adopt and implement investment promotion regimes for least developed countries"
            },
            {
              "id": "17.6",
              "number": "17.6",
              "name": "Enhance North-South, South-South, and triangular regional and international cooperation on and access to science, technology, and innovation and enhance knowledge sharing on mutually agreed terms, including through improved coordination among existing mechanisms, particularly at the United Nations level, and through a global technology facilitation mechanism"
            },
            {
              "id": "17.7",
              "number": "17.7",
              "name": "Promote the development, transfer, dissemination, and diffusion of environmentally sound technologies to developing countries on favorable terms, including on concessional and preferential terms, as mutually agreed"
            },
            {
              "id": "17.8",
              "number": "17.8",
              "name": "Fully operationalize the technology bank and science, technology, and innovation capacity-building mechanism for least developed countries by 2017 and enhance the use of enabling technology, in particular information and communications technology"
            },
            {
              "id": "17.9",
              "number": "17.9",
              "name": "Enhance international support for implementing effective and targeted capacity-building in developing countries to support national plans to implement all the Sustainable Development Goals, including through North-South, South-South and triangular cooperation "
            },
            {
              "id": "17.10",
              "number": "17.10",
              "name": "Promote a universal, rules-based, open, non-discriminatory and equitable multilateral trading system under the World Trade Organization, including through the conclusion of negotiations under its Doha Development Agenda "
            },
            {
              "id": "17.11",
              "number": "17.11",
              "name": "Significantly increase the exports of developing countries, in particular with a view to doubling the least developed countries' share of global exports by 2020"
            },
            {
              "id": "17.12",
              "number": "17.12",
              "name": "Realize timely implementation of duty-free and quota-free market access on a lasting basis for all least developed countries, consistent with World Trade Organization decisions, including by ensuring that preferential rules of origin applicable to imports from least developed countries are transparent and simple, and contribute to facilitating market access"
            },
            {
              "id": "17.13",
              "number": "17.13",
              "name": "Enhance global macroeconomic stability, including through policy coordination and policy coherence"
            },
            {
              "id": "17.14",
              "number": "17.14",
              "name": "Enhance policy coherence for sustainable development"
            },
            {
              "id": "17.15",
              "number": "17.15",
              "name": "Respect each country's policy space and leadership to establish and implement policies for poverty eradication and sustainable development"
            },
            {
              "id": "17.16",
              "number": "17.16",
              "name": "Enhance the Global Partnership for Sustainable Development, complemented by multi-stakeholder partnerships that mobilize and share knowledge, expertise, technology, and financial resources, to support the achievement of the Sustainable Development Goals in all countries, in particular developing countries"
            },
            {
              "id": "17.17",
              "number": "17.17",
              "name": "Encourage and promote effective public, public-private, and civil society partnerships, building on the experience and resourcing strategies of partnerships"
            },
            {
              "id": "17.18",
              "number": "17.18",
              "name": "By 2020, enhance capacity-building support to developing countries, including for least developed countries and small island developing states, to increase significantly the availability of high-quality, timely, and reliable data disaggregated by income, gender, age, race, ethnicity, migratory status, disability, geographic location, and other characteristics relevant in national contexts"
            },
            {
              "id": "17.19",
              "number": "17.19",
              "name": "By 2030, build on existing initiatives to develop measurements of progress on sustainable development that complement gross domestic product, and support statistical capacity-building in developing countries"
            },
          ]
        }
      ]
      ,
    }
  },

  computed: {},

  watch: {
    matrixType: {
      handler() {
        this.strategyDetailsStore.matrixTypeChanged()
      }
    },
    goalNumber: {
      handler() {
        this.strategyDetailsStore.goalNumberChanged()
      }
    },
  },

  mounted () {
    this.strategyDetailsStore.fetchCrosswalkAnalysis()
    this.strategyDetailsStore.showNext = false
    if (this.goalNumber === null || this.goalNumber === undefined || this.goalNumber === "") {
      this.goalNumber = 1
    }
  },

  methods: {}
}
